export default __webpack_public_path__ + "static/equipoDesktop-d5b8f88d590bea79568b6324bb6adef7.png";